/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import DescuentoForm from './DescuentoForm';
import * as validations from '../../validations/validations';
import * as descuentoActions from '../../actions/descuentoActions';
import * as userActions from '../../actions/userActions';
import * as menuActions from '../../actions/menuActions';
import * as cursoActions from '../../actions/cursoActions';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import withRouter from '../common/withRouter';
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import $ from 'jquery';
import {usuarioActual} from '../../util';
import dayjs from 'dayjs';

class ManageDescuentoForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			descuento:{
                fechaVigencia: new moment().format('DD/MM/YYYY'),
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        
    
        usuarioActual(this, "descuento",true).then( (usuario)=>{
            let id=this.props.id;

            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);

            if(id && id>0 ){

               this.props.descuentoActions.getDescuento(id, usuario).then( descuento=>{
                   this.setState({"descuento":descuento});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
            
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{
            
            }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
            
        
        })
    }
    
    
     fechas=(fechasArreglo, fechasCadena)=>{

        let elementState = this.state.descuento;
       
        elementState.fechaVigencia = fechasCadena
        elementState.fechadayJs = fechasArreglo;
        //new moment(fechasCadena).format("MM-DD-YYYY");
        //this.state.nuevo.fechaInicioExamen[0].format("DD-MM-YYYY");
        this.setState({descuento:elementState});
         
    }
    

    handleChange=(event, data)=> {

        let descuento = this.state.descuento;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        if(field=="iniciales"){
            if(value.length>2){
                toastr.error("Las iniciales deben ser de 2 caracteres");
                return;
            }
            
            
        }
        
        if(field=="noCupones"){
            if(value.length>3){
                toastr.error("El número mayor para cupones es de 999");
                return;
            }
        }
        
        
        if(field=="porcentaje"){
            if(value.length>3 || value>100){
                toastr.error("El porcentaje no debe ser mayor al 100 porciento");
                return;
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		descuento[field[0]]= value;
		else{
             if(!descuento[field[0]]){
                    descuento[field[0]]={}
                }
			descuento[field[0]][field[1]]= value;
		}
        
		
        this.setState({"descuento": descuento});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let descuento=this.state.descuento;
              
        if(!validations.requerido(descuento.cursoId)){
            errors.cursoId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(descuento.porcentaje)){
            errors.porcentaje=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(descuento.iniciales)){
            errors.iniciales=true;
            formIsValid=false;
        }
        
       
        if(!validations.requerido(descuento.noCupones)){
            errors.noCupones=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(descuento.fechaVigencia)){
            errors.fechaVigencia=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
        
        let newState=Object.assign({}, this.state.descuento);
        newState.fechaVigencia = dayjs(newState.fechadayJs).format('DD/MM/YYYY');
        
        this.props.descuentoActions.save(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate('/descuentos/');
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <DescuentoForm 
                    strings={this.state.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.descuento}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    fechas={this.fechas}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
   
    return {        
            ajaxCallInProgress:state.ajaxCallInProgress,
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            color:state.color,
            user:state.user, 
            idioma:state.idioma,
            form:state.form,
            strings:state.strings,
            cursoCombo:state.cursoCombo,
    }

}

function mapDispatchToProps(dispatch){

	return {   
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        descuentoActions: bindActionCreators(descuentoActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageDescuentoForm));